export class ProjectDataInformation {
  public tieneMuro: boolean = false;
  public tienePlacaBase: boolean = false;
  public alturaMuro: number = 0;
  public elevaciones: any[];
  public comentarios: string = '';

}
